__turbopack_context__.v({
  "apocalypse": "httpErrorPage-module-scss-module__MKWhEG__apocalypse",
  "barrenGlory": "httpErrorPage-module-scss-module__MKWhEG__barrenGlory",
  "bookBurning": "httpErrorPage-module-scss-module__MKWhEG__bookBurning",
  "button": "httpErrorPage-module-scss-module__MKWhEG__button",
  "counterspell": "httpErrorPage-module-scss-module__MKWhEG__counterspell",
  "curiosity": "httpErrorPage-module-scss-module__MKWhEG__curiosity",
  "deafeningSilence": "httpErrorPage-module-scss-module__MKWhEG__deafeningSilence",
  "etherswornCanonist": "httpErrorPage-module-scss-module__MKWhEG__etherswornCanonist",
  "forbiddenOrchard": "httpErrorPage-module-scss-module__MKWhEG__forbiddenOrchard",
  "gatekeeperOfMalakir": "httpErrorPage-module-scss-module__MKWhEG__gatekeeperOfMalakir",
  "ghostlyPrison": "httpErrorPage-module-scss-module__MKWhEG__ghostlyPrison",
  "lostInTheWoods": "httpErrorPage-module-scss-module__MKWhEG__lostInTheWoods",
  "mentalMisstep": "httpErrorPage-module-scss-module__MKWhEG__mentalMisstep",
  "message": "httpErrorPage-module-scss-module__MKWhEG__message",
  "obliterate": "httpErrorPage-module-scss-module__MKWhEG__obliterate",
  "oneWithNothing": "httpErrorPage-module-scss-module__MKWhEG__oneWithNothing",
  "outOfTime": "httpErrorPage-module-scss-module__MKWhEG__outOfTime",
  "possibilityStorm": "httpErrorPage-module-scss-module__MKWhEG__possibilityStorm",
  "powerSink": "httpErrorPage-module-scss-module__MKWhEG__powerSink",
  "ruleOfLaw": "httpErrorPage-module-scss-module__MKWhEG__ruleOfLaw",
  "silence": "httpErrorPage-module-scss-module__MKWhEG__silence",
  "sleep": "httpErrorPage-module-scss-module__MKWhEG__sleep",
  "stallForTime": "httpErrorPage-module-scss-module__MKWhEG__stallForTime",
  "temporaryLockdown": "httpErrorPage-module-scss-module__MKWhEG__temporaryLockdown",
  "timeStop": "httpErrorPage-module-scss-module__MKWhEG__timeStop",
  "totallyLost": "httpErrorPage-module-scss-module__MKWhEG__totallyLost",
  "unexpectedlyAbsent": "httpErrorPage-module-scss-module__MKWhEG__unexpectedlyAbsent",
  "winterOrb": "httpErrorPage-module-scss-module__MKWhEG__winterOrb",
  "wrongTurn": "httpErrorPage-module-scss-module__MKWhEG__wrongTurn",
  "zhalfirinVoid": "httpErrorPage-module-scss-module__MKWhEG__zhalfirinVoid",
});
